import useAxiosInstance from '../useAxiosInstance';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { ADD_ENTITY_DATA, ENTITY_DATA } from '../../constants/queryKeys';
import { showNotification } from '@publicisgroupe/p-os-components';
import { addEntity } from '../../services/ConfigService/EntityService';
import { Entity } from '../../interfaces/Entity';

export default function useAddEntityMutation() {
  const { axios } = useAxiosInstance();
  const queryClient = useQueryClient();

  return useMutation<string, AxiosError, { entityName: string; data: Entity }>(
    ADD_ENTITY_DATA,
    ({ entityName, data }) => addEntity(axios, entityName, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENTITY_DATA]);
        showNotification.success({
          title: 'Data Added!',
          content: `The data has been successfully added.`,
          inverted: true,
        });
      },
      onError: (error) => {
        showNotification.error({
          title: 'Data Not Added!',
          content: error?.message,
          inverted: true,
        });
      },
    }
  );
}
